import { QueryParam } from "../../../types/api/generic.type";
import { GetPotentialmatrixGeneralResponse } from "../../../types/api/potentialMatrix.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const PotentialMatrixGeneralService = {
  async get(
    queryParams: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetPotentialmatrixGeneralResponse> {
    const params = queryParams ? createQueryParamString(queryParams, true) : "";
    const response = await httpClient.get<GetPotentialmatrixGeneralResponse>(
      `v1/potential-matrix-general${params}`,
      { signal },
    );
    return response;
  },
};

export default PotentialMatrixGeneralService;
